import React from 'react';
import useSWR from 'swr';

import { useHandleSWR } from '~/libs/helpers'
import useGlobalState from '~/libs/context';

import TaxReturnImage from '~/public/official-docs/tax-return-reiwa-2.png';
import { CoveredCells, LabelCell, RawValueCell, ValueCell } from '../styles/StyledTaxReturn';
import { OfficialDocumentContainer } from './OfficialDocumentContainer';

const TaxReturn_2 = ({ isEnglish }) => {
	const { year } = useGlobalState(); 
	const { data: swrBalanceSheet } = useSWR(`/api/metrics/balanceSheet?year=${year}`);
  const { data: balanceSheet } = useHandleSWR(swrBalanceSheet, { assets: [], liabilities: [], totals: [] }, true);
  // TODO: Maybe we should find a way to get the totals directly from balanceSheet to avoid two requests
  const { data: swrProfitLoss } = useSWR(`/api/metrics/profitLoss?year=${year}`);
  const { data: profitLoss } = useHandleSWR(swrProfitLoss, { totals: [] }, true);
  const force = isEnglish;
  const debug = true;
  
	return (
    <OfficialDocumentContainer image={TaxReturnImage}>
      
      {/* Left Section */}
      <LabelCell en={"Label"} coords={[12.05, 8.1]} width={14.9} height={2.7} force={force} />
      <LabelCell en={"Label"} coords={[12.05, 24.2]} width={14.9} height={2.7} force={force} />

      <RawValueCell value={"1"} coords={[15.22, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"1"} coords={[15.22, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"2"} coords={[18.43, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"243423"} coords={[18.43, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"3"} coords={[21.64, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"34342"} coords={[21.64, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"4"} coords={[24.85, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"4"} coords={[24.85, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"5"} coords={[28.06, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"5"} coords={[28.06, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"6"} coords={[31.27, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"6"} coords={[31.27, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"7"} coords={[34.48, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"7"} coords={[34.48, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"8"} coords={[37.69, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"8"} coords={[37.69, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"9"} coords={[40.9, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"9"} coords={[40.9, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"10"} coords={[44.11, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"10"} coords={[44.11, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"11"} coords={[47.32, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"11"} coords={[47.32, 24.2]} width={14} height={2.7} force={force} />

      <RawValueCell value={"12"} coords={[50.53, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"12"} coords={[50.53, 24.2]} width={14} height={2.7} force={force} />

      <LabelCell en={"13"} coords={[53.74, 4.5]} width={3.2} height={2.8} force={force} />
      <ValueCell value={13} coords={[53.84, 8.05]} width={15.75} height={2.6} />

      <LabelCell en={"14"} coords={[56.95, 4.5]} width={3.2} height={2.8} force={force} />
      <ValueCell value={14} coords={[57.05, 8.05]} width={15.75} height={2.6} />

      <LabelCell en={"Total"} coords={[60.16, 4.5]} width={3.2} height={5.9} force={force} />
      <ValueCell value={666} coords={[61.88, 8.05]} width={15.75} height={2.6} />

      <LabelCell en={"Total"} coords={[66.58, 4.5]} width={3.2} height={2.8} force={force} />
      <RawValueCell value={"17"} coords={[66.58, 8.1]} width={14} height={2.7} force={force} />
      <RawValueCell value={"17"} coords={[66.58, 24.2]} width={14} height={2.7} force={force} />

      <CoveredCells coords={[9, 41.5]} width={54.8} height={58}>Coming soon!</CoveredCells>
      <CoveredCells coords={[70, 3.5]} width={37} height={25.5}>Coming soon!</CoveredCells> 
      <CoveredCells coords={[70, 41.5]} width={55} height={25.5}>Coming soon!</CoveredCells> 
      <CoveredCells coords={[95.8, 3.5]} width={75} height={3}></CoveredCells> 

    </OfficialDocumentContainer>
	);

};

export default TaxReturn_2;